import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import { MyRequestedServices } from './my-requested-services.model';

export const loadMyRequestedServicess = createAction(
  '[MyRequestedServices/API] Load MyRequestedServicess',
  props<{ myRequestedServicess: MyRequestedServices[] }>()
);

export const addMyRequestedServices = createAction(
  '[MyRequestedServices/API] Add MyRequestedServices',
  props<{ myRequestedServices: MyRequestedServices }>()
);

export const upsertMyRequestedServices = createAction(
  '[MyRequestedServices/API] Upsert MyRequestedServices',
  props<{ myRequestedServices: MyRequestedServices }>()
);

export const addMyRequestedServicess = createAction(
  '[MyRequestedServices/API] Add MyRequestedServicess',
  props<{ myRequestedServicess: MyRequestedServices[] }>()
);

export const upsertMyRequestedServicess = createAction(
  '[MyRequestedServices/API] Upsert MyRequestedServicess',
  props<{ myRequestedServicess: MyRequestedServices[] }>()
);

export const updateMyRequestedServices = createAction(
  '[MyRequestedServices/API] Update MyRequestedServices',
  props<{ myRequestedServices: Update<MyRequestedServices> }>()
);

export const updateMyRequestedServicess = createAction(
  '[MyRequestedServices/API] Update MyRequestedServicess',
  props<{ myRequestedServicess: Update<MyRequestedServices>[] }>()
);

export const deleteMyRequestedServices = createAction(
  '[MyRequestedServices/API] Delete MyRequestedServices',
  props<{ id: string }>()
);

export const deleteMyRequestedServicess = createAction(
  '[MyRequestedServices/API] Delete MyRequestedServicess',
  props<{ ids: string[] }>()
);

export const clearMyRequestedServicess = createAction(
  '[MyRequestedServices/API] Clear MyRequestedServicess'
);


export const getMyRequestedService = createAction(
  '[MyRequestedServices/API] Get MyRequestedServices',
  props<{ filtering: any }>()
)
